<template>
    <div>
      <div class="inner-header ">
        <nav class="navbar fixed-top bg-white animate__animated animate__slideInRight" style="border: 1px solid transparent !important;">
          <a  @click="$router.go(-1)" class="back-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
                  <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                    <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                    <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
                  </g>
              </svg>
            </a>
            <a href="javascript:void(0);" class="link-title">Edit EOI Details</a>
        </nav>
        </div>
         <div class="outer-wrapper">
        <div class="inner-page bg-white animate__animated animate__slideInRight">
          <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card form-card h-100">
                        <div class="card-body p-0 mt-4">
                            <div class="row">
                                <div class="col-12">
                              <b-form @submit.prevent="UpdateEOI">
                                    <b-form-group>
                                      <label>Is Approved<span class="text-danger">*</span></label>
                                      <b-form-select   v-model="Eoi.is_approved" required :options="[{value: null, text: 'Select Is Approved'}, {value: true, text: 'Yes'},{value: false, text: 'No'}]" ></b-form-select>
                                      <!-- <b-form-input  type="text"   v-model="AddProject.builder_id" required placeholder="Builder Id" ></b-form-input> -->
                                  </b-form-group>
                                  <b-form-group class="mt-3">
                                    <label>Upload EOI Form<span class="text-danger">*</span></label>
                                      <label for="upload-logo" class="custom-upload-label">
                                          <b-form-file v-model="eoi_form" accept=".jpg, .jpeg, .pdf" required class="mt-3 custom-file-input" @change="uploadEOI" plain id="upload-logo"></b-form-file>
                                          <div class="mb-2 label-text">EOI Form * {{ eoi_form ? eoi_form.name : '' }}</div>
                                      </label>
                                    </b-form-group>
                                    <b-form-group class="fixed-footer">
                                      <b-button type="submit" variant="primary" block>Save</b-button>
                                    </b-form-group>
                                  </b-form>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        </div>
         </div>
        </div>
    </template>
    <script>
    export default {
      name: 'EOI',
      data() {
        return {
          eoi_form: null,
          Eoi: {
            is_approved: null,
            eoi_done_form: null,
          },
        }
      },
        methods: {
        uploadEOI() {
          this.Eoi.eoi_done_form = event.target.files[0];
        },
        UpdateEOI() {
          let senddata = new FormData();
          senddata.append('premium_enquiry[enquiry_eoi_form_attributes][eoi_done_form]',this.Eoi.eoi_done_form);
          senddata.append('premium_enquiry[enquiry_eoi_form_attributes][is_approved]',this.Eoi.is_approved);
          senddata.append('premium_enquiry[enquiry_eoi_form_attributes][premium_enquiry_id]',this.$route.params.id);
          this.$axios
              .put(`premium_enquiries/${this.$route.params.id}`, senddata,{
                headers:{'Content-Type': 'multipart/form-data'}
              })
              .then((res) => {
                  swal({
                      title: "EOI Updated!",
                      icon: "success",
                  }).then(this.$router.replace({ name: "EnqDetails",  params: {id: this.$route.params.id}}));
              })
              .catch((err) => {
                  if (err.response.status === 500) {
                      swal({
                          title: "Server Error!",
                          icon: "error",
                      });
                  } else {
                      swal({
                          title: "Error",
                          text: err.response.data.message,
                          icon: "error",
                      });
                  }
              });
        }
      }
    }
    </script>
    <style  scoped>

    .inner-page{
      min-height: 100vh;
      min-height: 100dvh;
      margin-top: 0;
      padding-top: 40px;
    }
    label {
      letter-spacing: 0.01em;
      font-size: 14px;
      font-weight: 500;
    }
    .form-control {
      font-size: 14px;
    }

    .form-card .custom-upload-label{
      width: 100%;
      padding: 16px;
    }
    .form-card .custom-upload-label::after{
      content: 'Upload';
      font-size: 12px;
      font-weight: 500;
      line-height: 14.52px;
      position: absolute;
      top: 48px;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .fixed-footer{
      margin-bottom: 0;
      position: fixed;
      bottom: 0;
      width: 100%;
      left: 0;
      padding: 16px;
    }
    </style>